<template>
    <div class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">
            <header>
                <v-card-title>Metas</v-card-title>
                <v-divider class="mx-3"></v-divider>
            </header>
            
            <v-tabs v-model="tab" v-if="userType === 'Administrador'">
                <v-tab value="gestor">Gestor</v-tab>
                <v-tab value="grupo">Grupo</v-tab>
                <v-tab value="despacho">Despacho</v-tab>
            </v-tabs>
            <v-window v-model="tab" v-if="userType === 'Administrador'">
                <v-window-item value="gestor">
                    <GestorMetas />
                </v-window-item>
                <v-window-item value="grupo">
                    <GruposMetas />
                </v-window-item>
                <v-window-item value="despacho">
                    <DespachoMetas />
                </v-window-item>
            </v-window>

            <GestorMetas v-if="userType === 'Supervisor'" />

        </v-card>
    </div>
    <SnackbarComponent :value="snackbarData"/>
</template>

<script>
import DespachoMetas from '@/views/graficasEstaticas/section-metas/DespachoMetas.vue'
import GestorMetas from '@/views/graficasEstaticas/section-metas/GestorMetas.vue'
import GruposMetas from '@/views/graficasEstaticas/section-metas/GruposMetas.vue'
import SnackbarComponent from '@/components/Snackbar.vue'
import { EncryptService } from '@/services/EncryptService'
export default {
    name: 'EstadisticaMetas',
    components: {
        SnackbarComponent,
        DespachoMetas,
        GestorMetas,
        GruposMetas,
    },
    data() {
        return {
            search: '',
            isLoading: false,
            tab: null,
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            userType: '',
            arrGroupList: [],
        }
    },
    async created () {
        const ENC_TYPE_USER = localStorage.getItem('TIPO')
        this.userType = await EncryptService.decrypt(ENC_TYPE_USER)        
    },
    methods: {
        
    },
}
</script>